import { type Ref, onMounted, onUnmounted, ref } from 'vue'

export function useElementTouch(
  elementRef: Ref<HTMLElement | null>,
  options: { delayAfterTouchEnd?: number } = { delayAfterTouchEnd: 1000 },
) {
  const isTouched = ref(false)

  const handleTouchStart = () => {
    isTouched.value = true
  }

  const handleTouchMove = (event: TouchEvent) => {
    if (elementRef.value && event.touches.length > 0) {
      const touch = event.touches[0]
      const rect = elementRef.value.getBoundingClientRect()
      isTouched.value
        = touch.clientX >= rect.left
        && touch.clientX <= rect.right
        && touch.clientY >= rect.top
        && touch.clientY <= rect.bottom
    }
  }

  if (process.client) {
    onMounted(() => {
      if (elementRef.value instanceof HTMLElement) {
        elementRef.value.addEventListener('touchstart', handleTouchStart)
        elementRef.value.addEventListener('touchmove', handleTouchMove)
      }
    })

    onUnmounted(() => {
      if (elementRef.value instanceof HTMLElement) {
        elementRef.value.removeEventListener('touchstart', handleTouchStart)
        elementRef.value.removeEventListener('touchmove', handleTouchMove)
      }
    })
  }

  return isTouched
}
